import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from 'core/constants/routes';

import { LoginHeader } from 'components/Header/LoginHeader';
import { SharedModal } from 'components/shared/Modal';

import { ResetEmailForm } from './components/ResetEmailForm';
import { ResetPasswordForm } from './components/ResetPasswordForm';

export const ResetPassword = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const redirectToLogin = () => {
		navigate(ROUTES.LOGIN);
	};

	return (
		<>
			<LoginHeader />

			<SharedModal isOpen handleClose={redirectToLogin}>
				{location.pathname === ROUTES.CREATE_NEW_PASSWORD ? (
					<ResetPasswordForm />
				) : (
					<ResetEmailForm />
				)}
			</SharedModal>
		</>
	);
};
